type ManualBookingHistory = {
  push: (path: string | { pathname: string }) => void;
};

export function navigateManualBookingHome(
  history: ManualBookingHistory,
  tempStars = (window as any).TempStars,
): void {
  history.push('loading');
  if (typeof tempStars?.App?.goReact === 'function') {
    tempStars.App.goReact('hygienistHome');
    return;
  }
  history.push({ pathname: 'hygienistHome' });
}
